import React, { useContext, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "State/AuthContext";
import { API_ENDPOINTS } from "config/ApiConfig";
import { decodeToken } from "Components/SbSessionCheckerComponent/SbSessionChecker";

const SsoCallback = () => {
  const {
    setAccessToken,
    setRefreshToken,
    setProfileName,
    setOrgDomain,
    setSubscriptionType,
    setEmail
  } = useContext(AuthContext);

  const navigate = useNavigate();

  const exchangeSsoToken = useCallback(
    async (authCode) => {
      try {
        const response = await fetch(API_ENDPOINTS.SSO_LOGIN_EXCHANGE, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ auth_code: authCode }),
        });

        const data = await response.json();

        // Persist tokens in localStorage + Context
        if (data?.access_token) {
          localStorage.setItem("access_token", data.access_token);
          setAccessToken(data.access_token);
          const decodedData = decodeToken(data?.access_token);
          setEmail(decodedData?.sub ?? "");
          localStorage.setItem("username", decodedData?.sub ?? "");
        }

        if (data?.refresh_token) {
          localStorage.setItem("refresh_token", data.refresh_token);
          setRefreshToken(data.refresh_token);
        }

        // Update user profile details
        if (data?.name) {
          localStorage.setItem("name", data.name);
          setProfileName(data.name)
        };
        if (data?.domain) {
          localStorage.setItem("domain", data.domain);
          setOrgDomain(data.domain)
        };
        if (data?.subscription_type)
          localStorage.setItem("subscription_type", data.subscription_type);
          setSubscriptionType(data.subscription_type);
        if (data?.auth_type) {
          localStorage.setItem("auth_type", data.auth_type);
        }
        if (data?.sso_idp_login_url) {
          localStorage.setItem("sso_idp_login_url", data.sso_idp_login_url);
        }
        // Redirect to dashboard
        navigate("/jobs-library");
      } catch (error) {
        console.error("SSO exchange error:", error);
        navigate("/login");
      }
    },
    [
      navigate,
      setAccessToken,
      setRefreshToken,
      setProfileName,
      setOrgDomain,
      setSubscriptionType,
    ]
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const authCode = params.get("auth_code");

    if (authCode) {
      exchangeSsoToken(authCode);
    } else {
      navigate("/login");
    }
  }, [exchangeSsoToken, navigate]);

  return (
    <div className="d-flex vh-100 vw-100 justify-content-center align-items-center bg-light">
      <div className="text-center p-4 bg-white rounded shadow">
        {/* Spinner */}
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>

        {/* Text */}
        <h5 className="text-dark mb-1">Signing you in...</h5>
        <p className="text-muted mb-0">Please wait a moment</p>
      </div>
    </div>
  );
};

export default SsoCallback;
